export default "__VITE_ASSET__BOXJr0Ar__"